import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767b8bb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush card-stretch flex-column" }
const _hoisted_2 = { class: "card-header mt-6" }
const _hoisted_3 = { class: "card-title flex-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Consentimentos", -1))
const _hoisted_6 = { class: "text-muted fw-bold fs-7" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = {
  key: 0,
  class: "card-body p-9"
}
const _hoisted_9 = { class: "d-flex flex-wrap" }
const _hoisted_10 = { class: "position-relative d-flex flex-center me-15 mb-7" }
const _hoisted_11 = { class: "position-absolute translate-middle start-50 top-50 d-flex flex-column flex-center ml-negative" }
const _hoisted_12 = { class: "fs-1 fw-bolder" }
const _hoisted_13 = { class: "d-flex flex-column justify-content-center flex-row-fluid pe-11 mb-5" }
const _hoisted_14 = { class: "d-flex fs-6 fw-bold align-items-center mb-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bullet me-3 views" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Visualizações", -1))
const _hoisted_17 = { class: "ms-auto fw-bolder text-gray-700" }
const _hoisted_18 = { class: "d-flex fs-6 fw-bold align-items-center mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bullet me-3 consents" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Total", -1))
const _hoisted_21 = { class: "ms-auto fw-bolder text-gray-700" }
const _hoisted_22 = { class: "d-flex fs-6 fw-bold align-items-center mb-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bullet me-3 all" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Aceitaram todos", -1))
const _hoisted_25 = { class: "ms-auto fw-bolder text-gray-700" }
const _hoisted_26 = { class: "d-flex fs-6 fw-bold align-items-center mb-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bullet me-3 custom" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Personalizados", -1))
const _hoisted_29 = { class: "ms-auto fw-bolder text-gray-700" }
const _hoisted_30 = { class: "text-muted mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routerLink = _resolveComponent("routerLink")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.account.stats.total) + " consentimentos", 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_routerLink, {
          class: "btn btn-light btn-active-light-primary btn-sm",
          to: "consents"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Visualizar todos")
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.series)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.percentage) + "%", 1)
              ]),
              _createVNode(_component_apexchart, {
                class: "mixed-widget-4-chart",
                options: _ctx.chartOptions,
                series: _ctx.series,
                height: _ctx.chartHeight
              }, null, 8, ["options", "series", "height"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.account.stats.views), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.account.stats.total), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.account.stats.all), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.account.stats.custom), 1)
              ])
            ]),
            _createElementVNode("span", _hoisted_30, "* Porcentagem de aceitação, em relação ao total de consentimentos recebidos no site " + _toDisplayString(_ctx.account.name), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}